import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useTaskAttachmentCount(taskId: string | undefined) {
  return useQuery({
    queryKey: ['task-attachment-count', taskId],
    queryFn: async () => {
      if (!taskId) return 0;

      const { data, error } = await supabase
        .from('task_email_links')
        .select(`
          email_messages!inner (
            has_attachments,
            email_attachments (
              id
            )
          )
        `)
        .eq('task_id', taskId);

      if (error) throw error;

      // Count total attachments across all linked emails
      const total = data?.reduce((sum, link: any) => {
        const attachmentCount = link.email_messages?.email_attachments?.length || 0;
        return sum + attachmentCount;
      }, 0) || 0;

      return total;
    },
    enabled: !!taskId,
  });
}
